<template>
	<div class="customer-reviews-details-group">
		<div
			class="customer-reviews-details-group__wrap"
			:class="{'open': isOpen || isAlwaysOpen}"
		>
			<div
				v-for="(value, key, index) in details"
				:key="index + key"
				class="customer-reviews-details-group__item"
			>
				<CustomerReviewsBar :value="value" :title="key" :rating="calculateValue(value)"/>
			</div>
		</div>
		<button
			v-if="!isAlwaysOpen"
			class="customer-reviews-details-group__text-toggle"
			@click="toggleCollapse()"
		>
			{{ isOpen ? 'Weniger' : 'Mehr' }} anzeigen
			<BaseIcon
				name="chevron"
				width="24"
				height="24"
				class="customer-reviews-details-group__arrow"
				:class="{'open': isOpen}"
			/>
		</button>
	</div>
</template>

<script lang="ts" setup>
import CustomerReviewsBar from '@lmt-rpb/CustomerReviewsBar/CustomerReviewsBar.vue';
import { type PropType } from 'vue';
import { useResizeCollapse } from '../../composables/resizeCollapse';
import BaseIcon from '@lmt-rpb/BaseIcon/BaseIcon.vue';
import { numberFormat } from '@/js/utils/numberUtils';

const props = defineProps({
	details: {
		type: Object as PropType<Record<string, number>>,
		required: true,
		validator(value: Record<string, number>) {
			return !!Object.keys(value).length;
		}
	},
	maxValue: {
		type: Number,
		required: false,
		default: 6,
	},
	isAlwaysOpen: {
		type: Boolean,
		required: true,
	}
});

const { isOpen, toggleCollapse } = useResizeCollapse();

const calculateValue = (value: number): string => {
	return numberFormat(Math.max(0, Math.min(value, props.maxValue)));
};

</script>

<style lang="scss" scoped>
.customer-reviews-details-group {
	&__wrap {
		display: grid;
		grid-template-columns: 1fr;
		justify-items: center;
		margin: 0;
		max-height: 20.8rem;
		overflow: hidden;
		transition: max-height 0.4s ease-in-out;

		@include media-query-up($breakpoint-small) {
			max-height: 16rem;
			grid-template-columns: repeat(3, 1fr);
			column-gap: 1.6rem;
		}

		&.open {
			max-height: 75rem;
		}
	}

	&__item {
		margin: 0;
		padding: 0.8rem 0;
		width: 100%;
	}

	&__text-toggle {
		margin-top: 1.6rem;
		text-align: right;
		font-size: $font-small-2;
		color: $color-primary;
		line-height: 2.6rem;
		width: 100%;
		background: none;
		border: none;
		outline: inherit;
	}

	&__arrow {
		margin-left: 1rem;
		transform: rotate(180deg);
		fill: currentcolor;
		vertical-align: middle;

		&.open {
			transform: rotate(0);
		}
	}
}
</style>
